import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { FolderTree, FileText, ShieldCheck, Lock, Settings } from 'lucide-react';

interface SitemapSection {
  title: string;
  icon: React.ElementType;
  links: {
    path: string;
    label: string;
  }[];
}

const sections: SitemapSection[] = [
  {
    title: 'Main Pages',
    icon: FolderTree,
    links: [
      { path: '/', label: 'Home' },
      { path: '/learn-more', label: 'Learn More' }
    ]
  },
  {
    title: 'Legal',
    icon: FileText,
    links: [
      { path: '/privacy', label: 'Privacy Policy' },
      { path: '/terms', label: 'Terms of Service' }
    ]
  },
  {
    title: 'Security & Compliance',
    icon: ShieldCheck,
    links: [
      { path: '/security', label: 'Security' },
      { path: '/compliance', label: 'Compliance' }
    ]
  },
  {
    title: 'Preferences & Accessibility',
    icon: Settings,
    links: [
      { path: '/accessibility', label: 'Accessibility' },
      { path: '/cookies', label: 'Cookie Preferences' }
    ]
  }
];

export default function SitemapPage() {
  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <div className="py-12">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center mb-8">
            <Lock className="h-8 w-8 text-brand-primary mr-3" />
            <h1 className="text-4xl font-bold">Sitemap</h1>
          </div>
          
          <div className="bg-white rounded-lg shadow-sm p-8">
            <div className="grid md:grid-cols-2 gap-8">
              {sections.map((section, index) => (
                <div key={index} className="space-y-4">
                  <div className="flex items-center space-x-2 text-lg font-semibold text-gray-900">
                    <section.icon className="h-5 w-5 text-brand-primary" />
                    <h2>{section.title}</h2>
                  </div>
                  <ul className="space-y-2 ml-7">
                    {section.links.map((link, linkIndex) => (
                      <li key={linkIndex}>
                        <Link
                          to={link.path}
                          className="text-gray-600 hover:text-brand-primary transition-colors"
                        >
                          {link.label}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}